import { computed, onBeforeMount, onBeforeUnmount, onMounted, ref } from 'vue';
import { mediaQuery } from '../../scripts/lib/mediaQuery';
import EventBus from '../../scripts/lib/EventBus.js';
import { readJsonFromDom } from '../../scripts/utils.js';

const templateElement = document.getElementById('badge-liste-template');
export default {
  template: templateElement ? templateElement.innerHTML : '',

  props: {
    certifiedColumns: {
      type: Array,
      required: false,
    },
    saleFlagContent: {
      type: String,
      required: false,
    },
    active: {
      type: Object,
      required: true,
    },
    previewArticle: {
      type: Object,
      required: false,
    },
    isEasyIron: {
      type: Boolean,
      required: false,
    },
    // abtest-ents-t7613-pdp-hide-mix-match
    hideMixAndMatchVariante1: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  setup(props) {
    const isMobileViewport = ref(mediaQuery.up_to_L);
    const neuFlagData = ref(null);
    const kombiModulHasOutfits = ref(true);

    const isNew = computed(() => {
      if (props.active.colors) {
        return neuFlagData.value.newItems.includes(
          props.previewArticle ? props.previewArticle.colors.active.colorId : props.active.colors.active.colorId,
        );
      }
      return neuFlagData.value.newItems.includes(props.active.salesId);
    });

    const hideMixAndMatchInVariante1 = computed(() => props.hideMixAndMatchVariante1 && kombiModulHasOutfits.value);

    function onKombiModulNotLoaded() {
      kombiModulHasOutfits.value = false;
    }

    onBeforeMount(() => {
      neuFlagData.value = readJsonFromDom('#entsBadgeData');
      mediaQuery.on('change:width', () => {
        isMobileViewport.value = mediaQuery.up_to_L;
      });
    });

    onMounted(() => {
      document.addEventListener('bewe:reco:outfits:not-loaded', onKombiModulNotLoaded);
      EventBus.emit('ents:vue:flags:update', {
        isEasyIron: props.isEasyIron,
        isNew: isNew.value,
      });
    });

    onBeforeUnmount(() => {
      document.removeEventListener('bewe:reco:outfits:not-loaded', onKombiModulNotLoaded);
    });

    const openCertifiedDrawer = () => {
      EventBus.emit('ents:vue:certified-columns:drawer:open');
    };

    return {
      isNew,
      isMobileViewport,
      neuFlagData,
      openCertifiedDrawer,
      hideMixAndMatchInVariante1,
    };
  },
};
